import { Component, OnInit } from '@angular/core';

import { environment } from 'src/environments/environment';
import { URL_WEB_SERVER } from '../../global/config';

declare var mapboxgl: any;

@Component({
  selector: 'app-mapbox-planmaestro',
  templateUrl: './mapbox-planmaestro.component.html',
  styleUrls: ['./mapbox-planmaestro.component.css']
})
export class MapboxPlanmaestroComponent implements OnInit {

  constructor() { }

  ngOnInit() {

    mapboxgl.accessToken = environment.mapBoxToken;

    var map = new mapboxgl.Map({
      container: 'mappm',
      style: 'mapbox://styles/zhyper/ckr6fw2040ws617pot375nci7',
      zoom: 14,
      center: [-71.978774, -13.516732],
    });
  }

}
